import React from "react";
import { Field } from "formik";

import { FormInput } from "../../../../../components/ui";
import { useAdminProviderDataContext } from "../../../../../context";

const RithmicUsernameInput: React.FC = () => {
  const { user } = useAdminProviderDataContext();
  const { allowed_features } = user;

  return (
    <Field
      disabled={!allowed_features.access_edit_rithmic_username_field}
      name="username"
      component={FormInput}
      label="Rithmic Username"
    />
  );
};

export default RithmicUsernameInput;
